/**
 * Create a query string from an object
 */
export function createQueryString(parameters: Record<string, string | number | boolean>): string {
  const queryString = new URLSearchParams();

  for (const key in parameters) {
    if (Object.prototype.hasOwnProperty.call(parameters, key)) {
      queryString.set(key, String(parameters[`${key}`]));
    }
  }

  return queryString.toString();
}
